import React, { useState } from "react";
import PropTypes from "prop-types";
import FileTile from "components/app/common/components/FileTile";
import { toaster } from "utils/toaster";

function VideoDownloadButton(props) {
    const [isDownloading, setIsDownloading] = useState(false);

    const handleDownload = async () => {
        if (isDownloading) return;
        
        setIsDownloading(true);
        
        try {
            // First, try to use the direct file URL if available
            if (props.video.file) {
                const link = document.createElement("a");
                link.href = props.video.file;
                link.download = `${props.eventTitle.replace(/\s+/g, "-")}.mp4`;
                link.target = "_blank";
                link.rel = "noopener noreferrer";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                return;
            }

            // If no direct file URL, try to get download URL from API
            const response = await fetch(`/api/v1/videos/${props.video.id}/download/`);
            
            if (!response.ok) {
                throw new Error("Download not available");
            }
            
            const data = await response.json();
            
            if (data.download_url) {
                const link = document.createElement("a");
                link.href = data.download_url;
                link.download = `${props.eventTitle.replace(/\s+/g, "-")}.mp4`;
                link.target = "_blank";
                link.rel = "noopener noreferrer";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                throw new Error("Download URL not provided");
            }
        } catch (error) {
            console.error("Video download error:", error);
            toaster.error("Video download is not available for this content.");
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <button
            className={"btn btn-full btn-secondary"}
            onClick={handleDownload}
            disabled={isDownloading}
        >
            <FileTile
                fileType="video"
                iconOnly
            />
            <span>{isDownloading ? "Downloading..." : "Download Video"}</span>
        </button>
    );
}

VideoDownloadButton.propTypes = {
    video: PropTypes.object.isRequired,
    eventTitle: PropTypes.string.isRequired,
};

export default VideoDownloadButton;
